import '~/components/svg-viz/svg-viz.tag'
import '~/components/data-selector.tag'
import '~/components/data-infobox.tag'
import '~/components/target-message.tag'


riot.tag2('gte-viz', '<a class="gteviz-anchor" id="gteviz"></a> <div class="gteviz-inner"> <svg-viz></svg-viz> <data-selector></data-selector> <data-infobox></data-infobox> <target-message></target-message> </div>', '', '', function(opts) {
});
